import React from 'react';
import { isNil } from 'lodash';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import {
  SubHeader,
  Controls,
  InlineControl,
  Reset,
  InlineText,
} from '../../reporting/sidebar/components';

function AxisFormattingConfig({ axis, active = false }) {
  const { get } = useReportConfiguration();

  let prefixKey = 'axisPrefix';
  let suffixKey = 'axisSuffix';
  if (!active) {
    prefixKey = 'secondaryAxisPrefix';
    suffixKey = 'secondaryAxisSuffix';
  }

  return (
    <>
      <SubHeader>Format</SubHeader>
      <Controls>
        <InlineControl>
          <InlineText configurationKey={prefixKey} size='small'>
            Prefix
          </InlineText>
          <InlineText configurationKey={suffixKey} size='small'>
            Suffix
          </InlineText>
          <Reset
            label={`Reset ${axis} axis formatting`}
            configurationKeys={[prefixKey, suffixKey]}
            className='ml-auto'
            disabled={
              (isNil(get(prefixKey)) || get(prefixKey) === '') &&
              (isNil(get(suffixKey)) || get(suffixKey) === '')
            }
          />
        </InlineControl>
      </Controls>
    </>
  );
}
export default AxisFormattingConfig;
